import { jsx } from 'react/jsx-runtime';
import { useScreenClass, Box } from '@vp/swan';
import 'react';
import { useMainContext } from '../../../contexts/MainContext.js';
import { StepIndicator } from '../components/ui/step-indicator/StepIndicator.js';

const HeaderSteps=()=>{const screenClass=useScreenClass();const{isSignedIn}=useMainContext();return jsx(Box,{"data-cy":"replacement-content-header-step-selector",mt:"7",mb:!isSignedIn&&["xs","sm"].includes(screenClass)?"6":0,children:jsx(StepIndicator,{})})};

export { HeaderSteps };
//# sourceMappingURL=HeaderSteps.js.map
